import React from "react";
import PropTypes from "prop-types";
import useLanguageChange from "../../../hooks/useLanguageChange";
import { LogFirebase } from "../../../services/firestore";
import { FIREBASE_EVENT_CATEGORY } from "../../../constants/FirebaseConstants";

const NotificationCustomToastModal = ({ closeToast, data }) => {
    const localisedValues = useLanguageChange();

    const handleDeny = (msg) => {
        data.closeModal(msg);
        closeToast(true);
        LogFirebase(FIREBASE_EVENT_CATEGORY.NOTIFICATION_TOAST, "click_on_close", {
            toastIdentity: msg.identity,
            requestType: msg.request_type == "1" ? "Mic" : "Camera",
        });
    };

    const handleAllow = (msg) => {
        closeToast(true);
        data.handleActionFunction(msg);
        LogFirebase(FIREBASE_EVENT_CATEGORY.NOTIFICATION_TOAST, "click_on_allow", {
            toastIdentity: msg.identity,
            requestType: msg.request_type == "1" ? "Mic" : "Camera",
        });
    };

    return (
        <div className='toast-notification-message-text'>
            <div className='toast-notification-msg-header'>
                <h4 className='toast-notification-msg-title'>{data.title}</h4>
                <button type='button' className='toast-notification-close-btn' onClick={() => handleDeny(data.msg)}>
                    <span className='btn-icon icon-close-light'></span>
                </button>
            </div>
            <div className='toast-notification-footer'>
                <div className='button-inline more-space button-inline-tb-space d-flex align-items-center justify-content-end'>
                    <div className='button'>
                        <button className='btn default-btn-link' onClick={() => handleDeny(data.msg)}>
                            {localisedValues?.deny}
                        </button>
                    </div>
                    <div className='button'>
                        <button className='btn default-btn-primary' onClick={() => handleAllow(data.msg)}>
                            {localisedValues?.allow}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

NotificationCustomToastModal.propTypes = {
    closeToast: PropTypes.func,
    data: PropTypes.object,
};

export default NotificationCustomToastModal;
